








































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Button, Form, FormItem, Input, Message } from "element-ui";
import { axiosInstance } from "../../utils/axios";
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);

@Component({
    name: "ChangePassword",
})
export default class ChangePassword extends Vue {
    form = {
        newPass: "",
        checkPass: "",
        oldPass: "",
    };

    async submitForm() {
        console.log(this.form.oldPass, this.form.checkPass);
        if (this.form.newPass !== this.form.checkPass) {
            throw Message({
                showClose: true,
                message: "Password doesn't match",
                type: "error",
            });
        }
        try {
            await axiosInstance.put("/user/password", {
                oldPassword: this.form.oldPass,
                newPassword: this.form.newPass,
            });
            Message({
                showClose: true,
                message: "Change password successful",
                type: "success",
            });
            this.form.newPass = "";
            this.form.oldPass = "";
            this.form.checkPass = "";
        } catch (e) {
            Message({
                showClose: true,
                message: e,
                type: "error",
            });
        }
    }
}
